<cdk-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- Empty fallback template should match layer groups with no children, which will not be rendered -->
    <cdk-nested-tree-node *cdkTreeNodeDef="let node" class="leaf-node"></cdk-nested-tree-node>

    <!-- This is the tree node template for layers -->
    <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: isLayer" class="leaf-node">
        <ng-container *ngIf="node">
            <app-layer-group-item
                [layer]="node.layer"
                (selectLayer)="selectLayer($event)"
            ></app-layer-group-item>
        </ng-container>
    </cdk-nested-tree-node>

    <!-- This is the tree node template for layer groups -->
    <cdk-nested-tree-node
        *cdkTreeNodeDef="let node; when: isLayerGroupWithChildren"
        class="tree-node"
    >
        <div class="group-container">
            <button
                cdkTreeNodeToggle
                class="icon-button"
                [attr.aria-label]="'Toggle ' + node.name"
                (click)="toggleExpandBtn(node.id, treeControl.isExpanded(node))"
            >
                <cds-icon
                    shape="angle"
                    [direction]="treeControl.isExpanded(node) ? 'down' : 'right'"
                    class="toggle-icon"
                ></cds-icon>
            </button>
            <app-layer-group-title
                [groupInfo]="{ name: node.name, id: node.id }"
                [showShowAllButton]="
                    !!(searchKeyExists$ | async) &&
                    numOfVisibleLayers(node) !== node.children?.length
                "
                [showHideAllButton]="!!numOfVisibleLayers(node)"
                (selectLayerGroup)="selectLayerGroup($event)"
                (showAllLayers)="showAllLayers(node.id)"
                (hideAllLayers)="hideAllLayers(node.id)"
            ></app-layer-group-title>
        </div>
        <ng-container *ngIf="treeControl.isExpanded(node)">
            <ng-container cdkTreeNodeOutlet></ng-container>
        </ng-container>
    </cdk-nested-tree-node>
</cdk-tree>
